import { Heading } from '@hungryroot/ramen';

import styles from './RdpHeader.module.css';

interface Props {
  testid?: string;
  title: string;
}

export function RdpHeader(props: Props) {
  const { testid, title } = props;
  return (
    <Heading testid={testid} variant="H3" className={styles.title}>
      {title}
    </Heading>
  );
}
